// src/components/Pages/AccountPage/Utils/onboardingPopups.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./CenterOnlyLayout";

const OnboardingPopups = () => {
  const [showPopup, setShowPopup] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Prevent body scroll when popup is open
    if (showPopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showPopup]);

  const handleClose = () => {
    setShowPopup(false);
    
    // Update first login status
    const loggedIn = JSON.parse(localStorage.getItem("userLoggedin"));
    const users = JSON.parse(localStorage.getItem("users")) || [];

    if (loggedIn && users.length > 0) {
      const userIndex = users.findIndex(
        (u) =>
          (u.userId === loggedIn.login ||
            u.email === loggedIn.login ||
            u.mobile === loggedIn.login) &&
          u.password === loggedIn.password
      );

      if (userIndex !== -1) {
        users[userIndex].firstTimeLogin = false;
        localStorage.setItem("users", JSON.stringify(users));
      }
    }
  };

  const handleNavigation = (path) => {
    handleClose();
    navigate(path);
  };

  if (!showPopup) return null;

  const userId = JSON.parse(localStorage.getItem("userLoggedin"))?.login || "";

  return (
    <div className="onboarding-overlay-mob">
      <div className="onboarding-popup-mob">
        <div className="onboarding-header-mob">
          <h2 className="onboarding-title-mob">Welcome to Oowlet!</h2>
          <p className="onboarding-subtitle-mob">
            Choose an action to get started
          </p>
          <button 
            className="onboarding-close-btn-mob" 
            onClick={handleClose}
            aria-label="Close popup"
          >
            ✕
          </button>
        </div>

        <div className="onboarding-buttons-mob">
          <button
            className="onboarding-action-btn-mob"
            onClick={() => handleNavigation("/create-profile")}
          >
            <span className="btn-icon-mob">➕</span>
            <span className="btn-text-mob">Create Profile</span>
          </button>

          <button
            className="onboarding-action-btn-mob"
            onClick={() => handleNavigation(`/user-profiles/${userId}`)}
          >
            <span className="btn-icon-mob">👤</span>
            <span className="btn-text-mob">View Profiles</span>
          </button>

          <button
            className="onboarding-action-btn-mob"
            onClick={() => handleNavigation(`/user-friends/${userId}`)}
          >
            <span className="btn-icon-mob">👥</span>
            <span className="btn-text-mob">Find Friends</span>
          </button>

          <button
            className="onboarding-action-btn-mob"
            onClick={() => handleNavigation(`/user-groups/${userId}`)}
          >
            <span className="btn-icon-mob">🏘️</span>
            <span className="btn-text-mob">Join Groups</span>
          </button>

          <button
            className="onboarding-action-btn-mob"
            onClick={() => handleNavigation(`/useraccount-explore/${userId}`)}
          >
            <span className="btn-icon-mob">🔍</span>
            <span className="btn-text-mob">Explore</span>
          </button>

          <button
            className="onboarding-action-btn-mob"
            onClick={() => handleNavigation(`/settings/${userId}`)}
          >
            <span className="btn-icon-mob">⚙️</span>
            <span className="btn-text-mob">Settings</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingPopups;
